module.exports = __webpack_public_path__ + "img/R6_research.976a429d.png";